export const DataUnit = ({caption, data}) => (
    <div className="data-unit">
        <div className="data-cap">{caption}</div>
        <div className="data-text">{data}</div>
    </div>
)